import React, { Component } from "react";
import Layout from "../Layout/layout";
import { Helmet } from "react-helmet";
import "../styles/home/home.scss";
import { Row, Col } from "react-bootstrap";
import CardBox from "./home/cardBox";
import FirstBox from "./home/firstBox";
import SecondBox from "./home/secondBox";
import DepotTable from "./home/depotTable";
import AwaitingTable from "./home/awaitingTable";
import UninstalledTable from "./home/uninstalledTable";
import PowercutTable from "./home/powercutTable";
import DuressTable from "./home/duressTable";
import { apiHost } from "../api/apiClient";
import axios from "axios";
import HomePageToggleBar from "./commoncomponents/homePageToggleBar";
import renderHTML from "react-render-html";
import "./../styles/tools/colors.scss";
import signalRHelper from "../utils/signalRHelper";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableContent: false,
      depotList: [],
      totalDepots: "",
      awaitingList: [],
      awaitingInstallAsset: "",
      uninstalledList: [],
      maintenanceList: [],
      notRespondingList: [],
      powerCutList: [],
      duressList: [],
      totalAsset: "",
      activeAsset: "",
      activeCount: "",
      awaitingCount: "",
      uninstalledCount: "",
      maintenanceCount: "",
      notrespondingCount: "",
      respondingCount: "",
      realRespondingCount: "",
      activePercentage: "",
      awaitPercentage: "",
      uninstalledPercentage: "",
      maintenancePercentage: "",
      notrespondingPercentage: "",
      firstActivePercentage: "",
      firstUninstalledPercentage: "",
      firstAwaitingPercentage: "",
      inDepotPercentage: "",
      inDepot: "",
    };
    this.totalAsset = 0; //
    this.awaitinginstallcount = 0; //
    this.uninstallcount = 0; //
    this.active = 0;
    this.notresponding = 0; //
    this.dataSet = {};
  }
  componentDidMount() {
    this.getPowercutData();
    this.getAssetData();
    this.getNotRespondingData();
    this.getDepotListData();
    this.getDuresslistData();
    this.handleSignalR();
  }

  componentWillUnmount() {
    this.releaseSignalR();
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }

    // Release signalR handlers
    signalRHelper.unsubscribe('Duress');
    signalRHelper.unsubscribe('RealTimeAssetsAdd');
    signalRHelper.unsubscribe('RealTimeAssetsUpdate');
    signalRHelper.unsubscribe('RealTimeDepotAdd');
    signalRHelper.unsubscribe('RealTimeNotResponding');
    signalRHelper.unsubscribe('Powercut');

    this.connection.off("Duress");
    this.connection.off("RealTimeAssetsAdd");
    this.connection.off("RealTimeAssetsUpdate");
    this.connection.off("RealTimeDepotAdd");
    this.connection.off("RealTimeNotResponding");
    this.connection.off("Powercut");
    this.connection = null;
  }

  //abhilash created
  handleDuressAndBehaviourCall = async () => {
    try {
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        duressList: alertsList.data.Duress,
      });

    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  //abhilash created
  handleNotificationCall = async () => {
    try {
      let notification = await axios.get(
        `${apiHost}/api/Notification/LatestNotification`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ alertsNotificationList: notification.data });
      this.notificationPendingAlertCalculation();
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  getDuresslistData = async () => {
    // DuressAlertEventsForDashboard
    try {
      let duress = await axios.get(
        `${apiHost}/api/Event/DuressAlertEventsForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        duressList: duress.data,
      });

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  getNotRespondingData = async () => {
    // NotRespondingAssetForDashboard
    try {
      let notresponding = await axios.get(
        `${apiHost}/api/Assets/NotRespondingAssetForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        notrespondingCount: notresponding.data.length,
        notRespondingList: notresponding.data,
      });
      this.notresponding = notresponding.data.length;
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.tunnelConnection();
  };

  tunnelConnection = () => {
    signalRHelper.subscribe('Duress');
    signalRHelper.subscribe('RealTimeAssetsAdd');
    signalRHelper.subscribe('RealTimeAssetsUpdate');
    signalRHelper.subscribe('RealTimeDepotAdd');
    signalRHelper.subscribe('RealTimeNotResponding');
    signalRHelper.subscribe('Powercut');

    this.connection.on("Duress", (data) => {
      this.data = data;
      this.handleDuressAndBehaviourCall();
    });
    this.connection.on("RealTimeAssetsAdd", (data) => {
      this.data = data;
      this.getAssetData();
    });
    this.connection.on("RealTimeAssetsUpdate", (data) => {
      this.data = data;
      this.getAssetData();
      this.getDepotListData();
    });
    this.connection.on("RealTimeDepotAdd", (data) => {
      this.data = data;
      this.getDepotListData();
    });
    this.connection.on("RealTimeNotResponding", (data) => {
      this.data = data;
      this.getDepotListData();
      this.getNotRespondingData();
    });
    this.connection.on("Powercut", (data) => {
      this.data = data;
      this.getPowercutData();
    });
  };

  createPowercutList = (data) => {
    let counter = 0;
    let currentList = [...this.state.powerCutList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });
    if (counter == 0) {
      currentList.push(data);
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.created);
      var date2 = new Date(y.created);
      return date2 - date1;
    });

    this.setState({
      powerCutList: currentList,
    });
    this.getDepotListData();
  };

  createDuressList = (data) => {
    let counter = 0;
    let currentList = [...this.state.duressList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });
    if (counter == 0) {
      currentList.push(data);
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.created);
      var date2 = new Date(y.created);
      return date2 - date1;
    });

    this.setState({
      duressList: currentList,
    });
    this.getDepotListData();
  };

  getNotRespondingData = async () => {
    // NotRespondingAssetForDashboard
    try {
      let notresponding = await axios.get(
        `${apiHost}/api/Assets/NotRespondingAssetForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        notrespondingCount: notresponding.data.length,
        notRespondingList: notresponding.data,
      });
      this.notresponding = notresponding.data.length;
      this.dataSet.responding = notresponding.data.length;

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getAssetData = async () => {
    try {
      let assets = await axios.get(
        `${apiHost}/api/Assets/AssetListForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      let activeAssets = parseInt(assets.data.totalAsset) - parseInt(assets.data.awaitingInstallAssetDtoForDashbords.length) - parseInt(assets.data.unInstalledAssetDtoForDashbords.length) - parseInt(assets.data.maintenanceAssetDtoForDashbords.length);

      if (isNaN(activeAssets)) activeAssets = 0;

      this.setState({
        totalAsset: assets.data.totalAsset,
        awaitingCount: assets.data.awaitingInstallAssetDtoForDashbords.length,
        uninstalledCount: assets.data.unInstalledAssetDtoForDashbords.length,
        maintenanceCount: assets.data.maintenanceAssetDtoForDashbords.length,
        awaitingList: assets.data.awaitingInstallAssetDtoForDashbords,
        uninstalledList: assets.data.unInstalledAssetDtoForDashbords,
        maintenanceList: assets.data.maintenanceAssetDtoForDashbords,
        activeAsset: activeAssets,
      });

      const dataSet = {
        totalAsset: assets.data.totalAsset,
        awaitingInstallAsset: assets.data.awaitingInstallAssetDtoForDashbords.length,
        uninstalledAsset: assets.data.unInstalledAssetDtoForDashbords.length,
        maintenanceAsset: assets.data.maintenanceAssetDtoForDashbords.length,
        responding: this.dataSet.responding,
        inDepot: this.dataSet.inDepot,
      };

      this.dataSet = dataSet;
      this.calculations();
      this.totalAsset = assets.data.totalAsset;
      this.awaitinginstallcount = assets.data.awaitingInstallAssetDtoForDashbords.length;
      this.uninstallcount = assets.data.unInstalledAssetDtoForDashbords.length;
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  calculations = (data) => {
    const {
      totalAsset,

      awaitingInstallAsset,
      uninstalledAsset,
      maintenanceAsset,

      responding,
      inDepot,
    } = this.dataSet;

    let activeAssets = parseInt(totalAsset) - parseInt(awaitingInstallAsset) - parseInt(uninstalledAsset);

    let firstActivePercentage = Math.round((activeAssets / totalAsset) * 100);
    if (isNaN(firstActivePercentage)) firstActivePercentage = 0;

    let firstUninstalledPercentage = Math.round((awaitingInstallAsset / totalAsset) * 100);
    if (isNaN(firstUninstalledPercentage)) firstUninstalledPercentage = 0;

    let firstAwaitingPercentage = Math.round((uninstalledAsset / totalAsset) * 100);
    if (isNaN(firstAwaitingPercentage)) firstAwaitingPercentage = 0;

    let realRespondingCount = activeAssets - parseInt(responding);
    if (isNaN(realRespondingCount)) realRespondingCount = 0;

    let activePercentage = Math.round(((activeAssets - parseInt(responding)) / activeAssets) * 100);
    if (isNaN(activePercentage)) activePercentage = 0;

    let awaitPercentage = Math.round((awaitingInstallAsset / totalAsset) * 100);
    if (isNaN(awaitPercentage)) awaitPercentage = 0;

    let uninstalledPercentage = Math.round((uninstalledAsset / totalAsset) * 100);
    if (isNaN(uninstalledPercentage)) uninstalledPercentage = 0;

    let maintenancePercentage = Math.round((maintenanceAsset / responding) * 100);
    if (isNaN(maintenancePercentage)) maintenancePercentage = 0;

    let notrespondingPercentage = Math.round((responding / activeAssets) * 100);
    if (isNaN(notrespondingPercentage)) notrespondingPercentage = 0;

    let inDepotPercentage = Math.round((inDepot / activeAssets) * 100);
    if (isNaN(inDepotPercentage)) inDepotPercentage = 0;


    this.setState({
      activePercentage,
      awaitPercentage,
      uninstalledPercentage,
      maintenancePercentage,
      notrespondingPercentage,
      activeAsset: activeAssets,
      firstActivePercentage,
      firstUninstalledPercentage,
      firstAwaitingPercentage,
      inDepotPercentage,
      realRespondingCount,
    });
  };

  getDepotListData = async () => {
    try {
      let depots = await axios.get(
        `${apiHost}/api/Depots/DepotListForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        depotList: depots.data.depotAssetDtoForDashbords,
        totalDepots: depots.data.totalDepots,
        inDepot: depots.data.inDepot,
      });

      this.dataSet.inDepot = depots.data.inDepot;

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getPowercutData = async () => {
    // /api/Event/PowerCutEventsForDashboard

    try {
      let powercuts = await axios.get(
        `${apiHost}/api/Event/PowerCutEventsForDashboard`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (powercuts.data.length > 0) {
        this.setState({
          powerCutList: powercuts.data
        });
      }

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getDashboardData = async () => {
    try {
      await axios.get(
        `${apiHost}/api/Dashboard/DashboardContent`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  handleNanCase = (value) => { };

  render() {
    const {
      depotList,
      totalDepots,
      awaitingList,
      uninstalledList,
      totalAsset,
      awaitingCount,
      uninstalledCount,
      maintenanceCount,
      notrespondingCount,
      activePercentage,
      awaitPercentage,
      uninstalledPercentage,
      maintenancePercentage,
      activeAsset,
      firstActivePercentage,
      firstAwaitingPercentage,
      firstUninstalledPercentage,
      maintenanceList,
      notRespondingList,
      powerCutList,
      duressList,
      notrespondingPercentage,
      inDepot,
      inDepotPercentage,
      realRespondingCount,
    } = this.state;
    const awaitinstall = `<span>of <span className="goldColor">${totalAsset}</span> total fleet</span>`;
    const uninstall = `<span>of <span className="goldColor">${totalAsset}</span> total fleet</span>`;
    const responding = `<span>of <span className="goldColor"> ${totalAsset}</span> total fleet</span>`;
    const notresponding = `<span>of <span className="goldColor">  ${activeAsset}</span> active fleet </span>`;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Dashboard </title>
          </Helmet>
          <div className="contentBodyHome">
            <div className="contentWrapper">
              <h2 className="dashHeader">
                <strong>Dashboard </strong>
                <span className="dashHeaderSmall">v1.8.0</span>
              </h2>
              <div className="dashboardBody">
                <Row>
                  <Col sm="6">
                    <FirstBox
                      value={totalAsset}
                      name="total fleet"
                      progressValue1={firstActivePercentage}
                      progressResponse1="Active"
                      progressValue2={firstUninstalledPercentage}
                      progressResponse2="Awaiting install"
                      progressValue3={firstAwaitingPercentage}
                      progressResponse3="Uninstalled"
                    />
                  </Col>
                  <Col sm="6">
                    <SecondBox
                      name={totalDepots}
                      content="total depots"
                      progressValue={inDepotPercentage}
                      progressResponse={`${inDepot} ASSETS IN DEPOT OF ${activeAsset} ACTIVE FLEET`}
                      percentage={inDepot}
                      p1={inDepotPercentage}
                      p2={100 - inDepotPercentage}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col sm="2">
                    <CardBox
                      name={isNaN(activeAsset) ? 0 : activeAsset}
                      icon="fa fa-heartbeat"
                      response="active"
                      progressValue={activePercentage}
                      progressResponse={`${realRespondingCount} assets reporting`}
                      color="success"
                      textColor="#28A744"
                    />
                  </Col>
                  <Col sm="2">
                    <CardBox
                      name={awaitingCount}
                      icon="fa fa-wrench"
                      response="awaiting install"
                      progressValue={awaitPercentage}
                      progressResponse={renderHTML(awaitinstall)}
                      color="dark"
                    />
                  </Col>
                  <Col sm="2">
                    <CardBox
                      name={uninstalledCount}
                      icon="fa fa-archive"
                      response="uninstalled"
                      progressValue={uninstalledPercentage}
                      progressResponse={renderHTML(uninstall)}
                      textColor="#007BFF"
                    />
                  </Col>
                  <Col sm="2">
                    <CardBox
                      name={maintenanceCount}
                      icon="fa fa-search"
                      response="maintenance"
                      progressValue={maintenancePercentage}
                      progressResponse={renderHTML(responding)}
                      color="warning"
                      textColor="#FFC107"
                    />
                  </Col>
                  <Col sm="2">
                    <CardBox
                      name={notrespondingCount}
                      icon="fa fa-warning"
                      response="not responding"
                      progressValue={notrespondingPercentage}
                      progressResponse={renderHTML(notresponding)}
                      color="danger"
                      textColor="#DC3546"
                    />
                  </Col>
                </Row>
                <HomePageToggleBar
                  caption="Duress Alerts"
                  color="#D05454"
                  value={duressList.length}
                  open={true}
                >
                  <DuressTable duressList={duressList}></DuressTable>
                </HomePageToggleBar>
                <HomePageToggleBar
                  caption="Depots"
                  color="#666666"
                  value={depotList.length}
                  open={true}
                >
                  <DepotTable depotList={depotList}></DepotTable>
                </HomePageToggleBar>
                <HomePageToggleBar
                  caption="Awaiting install"
                  color="#2C3E50"
                  value={awaitingList.length}
                  open={false}
                >
                  <AwaitingTable awaitingList={awaitingList}></AwaitingTable>
                </HomePageToggleBar>
                <HomePageToggleBar
                  caption="uninstalled"
                  color="#2ab4c0"
                  value={uninstalledList.length}
                  open={false}
                >
                  <AwaitingTable awaitingList={uninstalledList}></AwaitingTable>
                </HomePageToggleBar>
                <HomePageToggleBar
                  caption="maintenance"
                  color="#E87E04"
                  value={maintenanceList.length}
                  open={false}
                >
                  <UninstalledTable
                    unInstalledList={maintenanceList}
                  ></UninstalledTable>
                </HomePageToggleBar>

                <HomePageToggleBar
                  caption="not responding"
                  color="#c5b96b"
                  value={notRespondingList.length}
                  open={false}
                >
                  <UninstalledTable
                    unInstalledList={notRespondingList}
                  ></UninstalledTable>
                </HomePageToggleBar>
                <HomePageToggleBar
                  caption="power cut events"
                  color="#4c87b9"
                  value={powerCutList.length}
                  open={true}
                >
                  <PowercutTable powerCutList={powerCutList}></PowercutTable>
                </HomePageToggleBar>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

export default Home;
